module.exports = __webpack_public_path__ + "img/go-back-arrow.a3c44758.svg";